import { ACTION_TYPES, usePrestacaoContasDispatch, usePrestacaoContasState } from "./prestacao-contas-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IPrestacaoContasPagedRequest } from "models/request/prestacao-contas-paged-request";
import { downloadFile } from "utils/download-file";

export const usePrestacaoContasController = () => {
    const dispatch = usePrestacaoContasDispatch();
    const { prestacaoContasPagedRequest } = usePrestacaoContasState();

    async function exportPrestacoesContas(format: string) {
        const file = await MunicipalPortalAAppService.exportPrestacoesContas(prestacaoContasPagedRequest, format);
        downloadFile(file);
    }

    async function onInit(initialTipoId?: number) {
        let request = { page: 0, pageSize: 10, idTipoDocumentoPrestacaoContas: initialTipoId } as IPrestacaoContasPagedRequest;

        dispatch({ type: ACTION_TYPES.setPrestacaoContasPagedRequest, payload: request });
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listPrestacoesContas(request);
        await loadLookups();

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [tipos, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listTiposDocumentoPrestacaoContas(),
                MunicipalPortalAAppService.getPrestacoesContasUltimaAtualizacao()
            ]);
            dispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listPrestacoesContas(request: IPrestacaoContasPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const [prestacoesContas, totais] = await Promise.all([
                MunicipalPortalAAppService.listPrestacoesContas(request),
                MunicipalPortalAAppService.getPrestacoesContasTotais({
                    term: request.term,
                    idTipoDocumentoPrestacaoContas: request.idTipoDocumentoPrestacaoContas,
                    ano: request.ano,
                }),
            ]);

            dispatch({ type: ACTION_TYPES.setPrestacoesContas, payload: prestacoesContas });
            dispatch({ type: ACTION_TYPES.setTotais, payload: totais });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar a prestação de contas. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...prestacaoContasPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listPrestacoesContas({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoDocumentoPrestacaoContas = e.target.value;
        } else if (e.target.name === "text-field-ano") {
            updated.ano = e.target.value ? Number(e.target.value) : undefined;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listPrestacoesContas({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setPrestacaoContasPagedRequest, payload: updated });
    };

    return { listPrestacoesContas, handleOnChange, onInit, exportPrestacoesContas };
}
